import { trackAnalyticsEvent } from '@eb/site-analytics';
import {
    GA_ACTION_CONTACT_ORG_ATTEMPT_EVENT,
    GA_CATEGORY_LISTING,
} from '../constants';

export const trackContactAction = (label: string) =>
    trackAnalyticsEvent({
        action: GA_ACTION_CONTACT_ORG_ATTEMPT_EVENT,
        category: GA_CATEGORY_LISTING,
        label,
    });
